// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2AHng","inner":"Form_inner__6OqA2","range":"Form_range__3xG8C","name":"Form_name__14QKm","actions":"Form_actions__2HHqj"};